/*
 * @Description: 
 * @Author: ADCannon
 * @Date: 2023-01-09 16:57:13
 * @FilePath: \app_2023NewYearParty\src\assets\js\bussiness.js
 */
import ajax from "./axios.config"
import utils from "./utils"
import config from "../config/index"
const share = require("../json/share.config.json");


const bussiness = {
    /**
     * 微信分享
     *
     * @author ADCannon
     * @date 2021/07/16
     */
    WeChatShare: function () {
        if (utils.browser.isWeiXin()) {
            ajax.jsonp("//db2.gamersky.com/getweixinsign.aspx", {
                url: url
            }).then(response => {
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: response.appId, // 必填，公众号的唯一标识
                    timestamp: response.timestamp, // 必填，生成签名的时间戳
                    nonceStr: response.nonceStr, // 必填，生成签名的随机串
                    signature: response.signature, // 必填，签名，见附录1
                    jsApiList: ['onMenuShareTimeline',
                        'onMenuShareAppMessage', 'onMenuShareQQ',
                        'onMenuShareWeibo', 'onMenuShareQZone',
                        'updateAppMessageShareData', 'updateTimelineShareData'
                    ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                });
                wx.ready(function () {
                    var shareData = {
                        title: share.title, // 分享标题
                        desc: share.subtitle, // 分享描述
                        link: config.shareUrl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                        imgUrl: share.sharePic, // 分享图标
                    }
                    if (wx.onMenuShareAppMessage) { //微信文档中提到这两个接口即将弃用
                        //分享到朋友圈
                        wx.onMenuShareTimeline(shareData);
                        //分享给朋友
                        wx.onMenuShareAppMessage(shareData);
                        //分享到QQ
                        wx.onMenuShareQQ(shareData);
                        //分享到QQ空间
                        wx.onMenuShareQZone(shareData);
                    } else {
                        //分享给朋友及分享到QQ
                        wx.updateAppMessageShareData(shareData);
                        //分享到朋友圈及分享到QQ空间
                        wx.updateTimelineShareData(shareData);
                    }
                    //分享到腾讯微博
                    wx.onMenuShareWeibo(shareData);
                });
            });
        }
    },

    /**
     * App内调起分享
     *
     * @author (Set the text for this tag by adding docthis.authorName to your settings file.)
     * @date 2021/07/16
     */
    AppShare: function (type = "url", share) {
        if (utils.isInAppWebView() == 5) {
            gsShareInfo.platform = "quanBu";
            gsShareInfo.type = type;
            gsShareInfo.title = share.title;
            gsShareInfo.description = share.description;
            gsShareInfo.url = share.shareUrl.appShare;
            gsShareInfo.thumbnailURL = share.sharePic;
            gsShareInfo.lotteryId = "0";
            GSAppFunc.share(gsShareInfo, function (response) {});
        } else {
            const shareInfo = GSAppJsApi.UI.createShareInfo('renYi', share.sharePic, share.title, share.description, share.contentUrl, '', 0, () => {})
            GSAppJsApi.UI.share(shareInfo);
        }
    },

    /**
     * 添加站内统计
     *
     * @author ADCannon
     * @date 2021/07/16
     * @param {Number} id 统计Id
     * @param {String} [device="wap"] wap为移动端统计， PC为PC端统计
     */
    SetHits: function (id, device = "wap") {
        let ApiUrl = "";
        device == 'wap' ? ApiUrl = "//click.gamersky.com/Common/GetWapHits.aspx" : ApiUrl = "//click.gamersky.com/Common/GetHits.aspx";
        ajax.jsonp(ApiUrl, {
            script: 3,
            id: id
        }).then(response => {});
    },
    /**
     * 事件和cms 统计
     * @param {String} eventName 统计事件名称
     * @param {String} eventParam 统计参数
     * @param {String} device 设备标识 pc 、h5 报 cms , app报本地后台和友盟
     */
    Record: function (eventName, eventParam, device = 'wap') {
        // app内统计
        if (device == 'wap') {
            // 事件统计
            GSAppJsApi.EventStatistics.recordEvent(eventName, eventParam, 0);
        } else {
            const cmsDevice = device === 'h5' ? 'wap' : 'pc'
            //cms 统计
            bussiness.SetHits(eventName, cmsDevice);
        }
    },
    // 友盟统计
    uMengRecord: function (eventId, paramId) {
        GSAppJsApi.UMeng.recordEvent(eventId, paramId);
    },
}

export default bussiness;